import type { Leap } from '../../data/types';

export type LeapState = 'past' | 'current' | 'upcoming';

export function leapState(leap: Leap, babyAgeWeeks: number): LeapState {
  const delta = babyAgeWeeks - leap.week;
  if (delta >= -2 && delta <= 4) return 'current';
  if (delta > 4) return 'past';
  return 'upcoming';
}
